import style from './Education.module.css';
import EducationItem from "./EducationItem";
import React from "react";
import Paginator from "../common/Paginator/Paginator";
import LoadingArea from "../common/LoadingArea/LoadingArea";



const Education = (props) => {

    return (
        <div className={style.contInst}>




                        <h3 className='mb-4'>Всего учебно-методических пособий: {props.totalCount} </h3>
                        <Paginator currentPage={props.currentPage} onPageChanged={props.onPageChanged}
                                   totalItemsCount={props.totalCount} pageSize={props.pageSize}/>
                        <LoadingArea loading={props.loading}>
                            {Array.isArray(props.articles)
                                ? props.articles.map(u => <EducationItem article={u} key={u.id}/>)
                                : null}
                        </LoadingArea>
                        <Paginator currentPage={props.currentPage} onPageChanged={props.onPageChanged}
                                   totalItemsCount={props.totalCount} pageSize={props.pageSize}/>




        </div>
    )
}
export default Education;